import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";
export var INSURANCE_STATUSES = _Object$freeze({
  pending_enrollment: 'pending_enrollment',
  enrolled: 'enrolled',
  not_enrolled: 'not_enrolled',
  rejected: 'rejected',
  pending_disenrollment: 'pending_disenrollment'
});
//# sourceMappingURL=constants.js.map